import './slidersHomePage.js'
import slidersHomePage from "./slidersHomePage.js";
import handleMarquee from "../modules/handleMarquee.js";
export default function pageHomePage(){
    if (document.querySelector('.page__home-page')){
        slidersHomePage();
        handleMarquee();
    }
}
